import React, { useState } from "react";
import {
    Typography,
    TextField,
    Button,
    Box,
    InputAdornment,
    IconButton,
    Card,
    CardContent,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoginUser } from "../utils/APIRequest";
import { STORAGE_KEYS } from "../utils/StorageKeys";

// interface AdminLoginProps {
//     onLoginSuccess: () => void;
// }

const LoginScreen: React.FC = () => {
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [showPassword, setShowPassword] = useState<boolean>(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!username.trim() || !password.trim()) {
            setError("Please enter both username and password");
            return;
        }
        const payload = {
            username: username,
            password: password,
        };
        const response = await LoginUser(payload)
        if (response && response?.statusCode === 200) {
            const data = response.data;
            localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.token);
            localStorage.setItem(STORAGE_KEYS.USER_TYPE, data.isAdmin === true ? "admin" : "employee");
            localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify({ name: data.name, id: data.id, lunchOpted: data.lunchOpted, designation: data.designation }));
            // onLoginSuccess();
            window.location.reload(); // Reload to reflect changes
        } else {
            setError("Invalid username or password");
        }
    }

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
    };


    return (
        <Box
            sx={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: (theme) => theme.palette.background.default }}
        >
            <Card sx={{ maxWidth: 400, width: "100%", mx: 2 }}>
                <CardContent sx={{ p: 3 }}>
                    <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
                        <img
                            src="/ThoughtDeskLogo.svg"
                            alt="ThoughtDesk Logo"
                            style={{ height: 90, marginBottom: 10 }}
                        />
                        <Typography component="h1" variant="h4" gutterBottom>
                            ThoughtDesk
                        </Typography>
                        <Typography variant="body2" color="text.secondary" textAlign="center">
                            Sign in
                        </Typography>
                    </Box>

                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                        <TextField
                            fullWidth
                            label="Username"
                            variant="outlined"
                            value={username}
                            onChange={(e) => {
                                setUsername(e.target.value);
                                setError("");
                            }}
                            sx={{ mb: 3 }}
                            error={!!error}
                            helperText={error ? error : ""}
                        />

                        <TextField
                            fullWidth
                            label="Password"
                            type={showPassword ? "text" : "password"}
                            variant="outlined"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError("");
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={toggleShowPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ mb: 3 }}
                            error={!!error}
                            helperText={error ? error : ""}
                        />

                        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} >
                            {"Sign In"}
                        </Button>
                    </Box>

                </CardContent>
            </Card>
        </Box>
    );
};

export default LoginScreen;